<div class="lg-sankey-chart" #root>
    <div class="lg-sankey-chart__wrapper" #chartHolder>
        @if (showColumnTitle) {
            <div class="lg-sankey-chart__wrapper__titles">
                @for (column of _columns; track column) {
                    <div class="lg-sankey-chart__column-title">
                        <div
                            class="lg-sankey-chart-column-title__title"
                            [style.height]="columnTitleHeight + 'px'"
                        >
                            @if (columnTitleTemplate) {
                                <div>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            columnTitleTemplate;
                                            context: { $implicit: column.column }
                                        "
                                    ></ng-container>
                                </div>
                            }
                            @if (getColumnText) {
                                <div>
                                    {{ getColumnText(column.column) }}
                                </div>
                            }
                            @if (!getColumnText && !columnTitleTemplate) {
                                <div>No callback or template available.</div>
                            }
                        </div>
                    </div>
                }
            </div>
        }

        <svg class="lg-sankey-chart__wrapper__svg"></svg>
        <div class="lg-sankey-chart__wrapper__nodes">
            @for (column of _columns; track column) {
                <div class="lg-sankey-chart__wrapper__nodes__column">
                    <div class="lg-sankey-chart-column__body">
                        <div
                            lgScrollable
                            [lgScrollableAutoHide]="true"
                            [lgScrollableWrapper]="false"
                            (scroll)="_onScrollEnd()"
                        >
                            @for (node of column.nodes; track node) {
                                <div
                                    class="lg-sankey-chart-node"
                                    [id]="chartId + node.id"
                                    [class.lg-sankey-chart-node--clickable]="
                                        node.dataNode.clickable && clickable
                                    "
                                    [style.height.px]="fixedNodeHeight ? nodeHeight : null"
                                    (click)="_onNodeClick(node)"
                                >
                                    <div class="lg-sankey-chart-node__indicator">
                                        <div class="lg-sankey-chart-node__indicator__left">
                                            @if (!hasVariableFlow) {
                                                <div
                                                    class="lg-sankey-chart-node__indicator__left__default"
                                                    [style.height.px]="node.value"
                                                ></div>
                                            }
                                            @if (hasVariableFlow) {
                                                <div>
                                                    <div
                                                        class="lg-sankey-chart-node__indicator__left__positive"
                                                        [style.height.px]="node.valueLeftPositive"
                                                    ></div>
                                                    <div
                                                        class="lg-sankey-chart-node__indicator__left__negative"
                                                        [style.height.px]="node.valueLeftNegative"
                                                    ></div>
                                                    <div
                                                        class="lg-sankey-chart-node__indicator__left__remaining"
                                                        [style.height.px]="
                                                            node.value - node.valueLeft
                                                        "
                                                    ></div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="lg-sankey-chart-node__content">
                                        <div
                                            class="lg-sankey-chart-node__content__flow"
                                            [style.height.px]="node.value"
                                        >
                                            @if (nodeTemplate) {
                                                <div
                                                    class="lg-sankey-chart-node__content__flow__text"
                                                >
                                                    <ng-container
                                                        *ngTemplateOutlet="
                                                            nodeTemplate;
                                                            context: { $implicit: node.dataNode }
                                                        "
                                                    ></ng-container>
                                                </div>
                                            }
                                            @if (getNodeText) {
                                                <div
                                                    class="lg-sankey-chart-node__content__flow__text"
                                                >
                                                    {{ getNodeText(node) }}
                                                </div>
                                            }
                                            @if (!nodeTemplate && !getNodeText) {
                                                <div
                                                    class="lg-sankey-chart-node__content__flow__text"
                                                >
                                                    No callback or template available.
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="lg-sankey-chart-node__indicator">
                                        <div class="lg-sankey-chart-node__indicator__right">
                                            @if (!hasVariableFlow) {
                                                <div
                                                    class="lg-sankey-chart-node__indicator__right__default"
                                                    [style.height.px]="node.valueRight"
                                                ></div>
                                            }
                                            @if (hasVariableFlow) {
                                                <div
                                                    class="lg-sankey-chart-node__indicator__right__positive"
                                                    [style.height.px]="node.valueRightPositive"
                                                ></div>
                                            }
                                            @if (hasVariableFlow) {
                                                <div
                                                    class="lg-sankey-chart-node__indicator__right__negative"
                                                    [style.height.px]="-node.valueRightNegative"
                                                ></div>
                                            }
                                            @if (hasVariableFlow) {
                                                <div
                                                    class="lg-sankey-chart-node__indicator__right__remaining"
                                                    [style.height.px]="node.value - node.valueRight"
                                                ></div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
